module.exports = __webpack_public_path__ + "static/icon-8a001060f518bffbf139c7afa2b165b0.png";